class MtKjFooter {
  constructor(root) {
    this.root = root;
    this.menus = Array.from(this.root.querySelectorAll('.mt-kj-footer__menu'));
    this._onToggleClick = this._onToggleClick.bind(this);
    this._onResize = this._onResize.bind(this);
    this._bindMenus();
    this._bindNewsletter();
    window.addEventListener('resize', this._onResize, { passive: true });
    this._syncMode();
  }

  destroy() {
    this.menus.forEach((menu) => {
      const btn = menu.querySelector('.mt-kj-footer__menu-toggle');
      if (btn) btn.removeEventListener('click', this._onToggleClick);
    });
    window.removeEventListener('resize', this._onResize);
  }

  _isMobile() {
    return window.matchMedia('(max-width: 980px)').matches;
  }

  _bindMenus() {
    this.menus.forEach((menu) => {
      const btn = menu.querySelector('.mt-kj-footer__menu-toggle');
      if (!btn) return;
      btn.addEventListener('click', this._onToggleClick);
    });
  }

  _onToggleClick(e) {
    const btn = e.currentTarget;
    const menu = btn.closest('.mt-kj-footer__menu');
    if (!menu) return;
    if (!this._isMobile()) return;

    const isOpen = menu.classList.contains('is-open');
    menu.classList.toggle('is-open', !isOpen);
    btn.setAttribute('aria-expanded', (!isOpen).toString());
  }

  _onResize() {
    this._syncMode();
  }

  _syncMode() {
    const mobile = this._isMobile();
    const wasMobile = this._mobileMode;
    this._mobileMode = mobile;
    this._syncMenusGap(mobile);
    this.menus.forEach((menu) => {
      const btn = menu.querySelector('.mt-kj-footer__menu-toggle');
      if (!btn) return;

      if (!mobile) {
        menu.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        if (wasMobile === false) {
          const shouldOpen = this.menus.indexOf(menu) === 0;
          menu.classList.toggle('is-open', shouldOpen);
          btn.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          return;
        }
        btn.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
      }
    });
  }

  _syncMenusGap(mobile) {
    if (mobile) return;
    const minWidth = 750;
    const maxWidth = 1440;
    const minGap = 8;
    const maxGap = 120;

    const w = window.innerWidth || maxWidth;
    const tRaw = (w - minWidth) / (maxWidth - minWidth);
    const t = Math.max(0, Math.min(1, tRaw));
    const gap = minGap + (maxGap - minGap) * t;
    this.root.style.setProperty('--mt-kj-footer-menus-gap', `${gap}px`);
  }

  _bindNewsletter() {
    const form = this.root.querySelector('.mt-kj-footer__newsletter-form');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const row = form.querySelector('.mt-kj-footer__newsletter-row');
      const success = form.querySelector('.mt-kj-footer__newsletter-success');
      const data = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((res) => {
          if (!(res.ok || res.status === 200 || res.redirected)) return;
          if (row) row.classList.add('hidden');
          if (success) {
            success.classList.remove('hidden');
          }
          form.reset();
        })
        .catch(() => {
          form.submit();
        });
    });
  }
}

const mtKjFooterInstances = new Map();

function initMtKjFooters() {
  document.querySelectorAll('.mt-kj-footer').forEach((root) => {
    const id = root.getAttribute('data-section-id') || root.id || Math.random().toString(36);
    if (mtKjFooterInstances.has(id)) return;
    mtKjFooterInstances.set(id, new MtKjFooter(root));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMtKjFooters);
} else {
  initMtKjFooters();
}

document.addEventListener('shopify:section:unload', (event) => {
  const root = event.target && event.target.querySelector && event.target.querySelector('.mt-kj-footer');
  if (!root) return;
  const id = root.getAttribute('data-section-id') || root.id;
  const inst = mtKjFooterInstances.get(id);
  if (inst) {
    inst.destroy();
    mtKjFooterInstances.delete(id);
  }
});
